export default __webpack_public_path__ + "static/media/alarmClockFilled.b109c5d9.svg";